<!-- src/app/pages/expediente/expediente-digital/sections/paraclinicos/paraclinicos-page/components/historico-laboratorio/historico-laboratorio.component.html -->

<div class="historico-container">
  <!-- Header -->
  <div class="historico-header">
    <div>
      <h3 class="titulo">Histórico de Laboratorios</h3>
      <p class="subtitulo" *ngIf="historico">
        {{ historico.parametros.length }} parámetros • {{ historico.fechas.length }} estudios
      </p>
    </div>

    <ion-button fill="outline" size="small" (click)="recargar()" [disabled]="isLoading">
      <ion-icon slot="start" name="refresh"></ion-icon>
      Actualizar
    </ion-button>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="loading-container">
    <ion-spinner color="primary"></ion-spinner>
    <p>Cargando histórico...</p>
  </div>

  <!-- Error -->
  <div *ngIf="error && !isLoading" class="error-container">
    <ion-icon name="alert-circle" color="danger"></ion-icon>
    <p>{{ error }}</p>
    <ion-button size="small" (click)="recargar()"> Reintentar </ion-button>
  </div>

  <!-- Tabla Histórico -->
  <div *ngIf="historico && !isLoading && !error" class="tabla-wrapper">
    <!-- Leyenda -->
    <div class="leyenda">
      <div class="leyenda-item">
        <span class="badge badge-normal">Normal</span>
      </div>
      <div class="leyenda-item">
        <span class="badge badge-bajo">Bajo</span>
      </div>
      <div class="leyenda-item">
        <span class="badge badge-alto">Alto</span>
      </div>
    </div>

    <!-- Tabla scrolleable -->
    <div class="tabla-scroll">
      <table class="tabla-historico">
        <thead>
          <tr>
            <th class="columna-parametro sticky-left">Parámetro</th>
            <th class="columna-unidad sticky-left-2">Unidad</th>
            <th class="columna-rango sticky-left-3">Rango</th>
            <th *ngFor="let fecha of historico.fechas" class="columna-fecha">
              <div class="fecha-header">
                <div class="fecha-corta">{{ formatearFecha(fecha) }}</div>
                <div class="fecha-completa">{{ formatearFechaCompleta(fecha) }}</div>
              </div>
            </th>
          </tr>
        </thead>

        <tbody>
          <!-- Agrupar por categoría -->
          <ng-container *ngFor="let categoria of objectKeys(getParametrosPorCategoria())">
            <!-- Encabezado de categoría -->
            <tr class="fila-categoria">
              <td [attr.colspan]="3 + historico.fechas.length" class="categoria-header">
                {{ categoria | titlecase }}
              </td>
            </tr>

            <!-- Parámetros de la categoría -->
            <tr *ngFor="let parametro of getParametrosPorCategoria()[categoria]">
              <!-- Nombre del parámetro (sticky) -->
              <td class="columna-parametro sticky-left">
                <span class="parametro-nombre">{{ parametro.parametroNombre }}</span>
              </td>

              <!-- Unidad (sticky) -->
              <td class="columna-unidad sticky-left-2">
                <span class="unidad-texto">{{ parametro.unidad }}</span>
              </td>

              <!-- Rango (sticky) -->
              <td class="columna-rango sticky-left-3">
                <span class="rango-texto">
                  <ng-container *ngIf="parametro.rangoMin !== undefined && parametro.rangoMax !== undefined">
                    {{ parametro.rangoMin }} - {{ parametro.rangoMax }}
                  </ng-container>
                  <ng-container *ngIf="parametro.rangoMin === undefined || parametro.rangoMax === undefined">
                    -
                  </ng-container>
                </span>
              </td>

              <!-- Valores por fecha -->
              <td *ngFor="let fecha of historico.fechas" [class]="getCeldaClass(parametro, fecha)">
                <ng-container *ngIf="getValorParaFecha(parametro, fecha) as valor">
                  <span class="valor-numero">{{ getValorTexto(valor) }}</span>
                  <ion-icon
                    *ngIf="valor.fueraRango && valor.nivel === 'alto'"
                    name="arrow-up"
                    class="icono-alerta"
                  ></ion-icon>
                  <ion-icon
                    *ngIf="valor.fueraRango && valor.nivel === 'bajo'"
                    name="arrow-down"
                    class="icono-alerta"
                  ></ion-icon>
                </ng-container>
                <span *ngIf="!getValorParaFecha(parametro, fecha)" class="valor-vacio">-</span>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <!-- Mensaje si no hay datos -->
    <div *ngIf="historico.parametros.length === 0" class="sin-datos">
      <ion-icon name="document-text-outline"></ion-icon>
      <p>No hay estudios de laboratorio registrados</p>
    </div>
  </div>
</div>
